import { Pagination } from "@mui/material";
import { UserMultipleIcon } from "hugeicons-react";
import { Mail, Search } from "lucide-react";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { LISTE_COORDO_PRESTATAIRE, PRESTATAIRE } from "../../Utils/constant";
import { Loader } from "../../components/Widget/Loader";
import { find } from "../../services/service";
import { useStoreApp } from "../../store/storeApp";

export const CoordonnateurEquipe = () => {
  const coordoList = useStoreApp();
  const [prestataires, setPrestataires] = useState([]);
  const [loadingPrestataire, setLoadingPrestataire] = useState(false);
  const [prestataireId, setPrestataireId] = useState("");

  useEffect(() => {
    prestataireId !== "" &&
      coordoList.getData(
        LISTE_COORDO_PRESTATAIRE + `/${prestataireId}/coordinateurs`,
        { page: 0, param: "", size: 10 },
        ``
      );
  }, [prestataireId]);

  useEffect(() => {
    const loadPrestataire = async () => {
      setLoadingPrestataire(true);
      try {
        const res = await find(PRESTATAIRE);
        const items = res?.data?.data ?? res?.data?.donnee ?? res?.data ?? [];
        setPrestataires(items);
        setPrestataireId(items[0]?.id || "");
      } catch (err) {
        console.error(err);
        setPrestataires([]);
      } finally {
        setLoadingPrestataire(false);
      }
    };
    loadPrestataire();
  }, []);

  const more = async (page) => {
    coordoList.getData(
      LISTE_COORDO_PRESTATAIRE + `/${prestataireId}/coordinateurs`,
      { page: page - 1, param: "", size: 10 },
      ""
    );
  };

  return (
    <div className="">
      <>
        <div className="space-y-1 mb-6">
          <h3 class="font-mtn text-3xl font-bold">Gestion d'equipe</h3>
          <p className="text-sm text-gray-500">
            Gérez les equipes des coordonnateurs associés à chaque prestataire .
          </p>
        </div>

        <div className="flex items-center ">
          <div className="relative flex-1 max-w-sm">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              onChange={(e) => {
                coordoList.getData(
                  LISTE_COORDO_PRESTATAIRE + `/${prestataireId}/coordinateurs`,
                  { page: 0, param: e.target.value, size: 10 },
                  ""
                );
              }}
              type="text"
              placeholder="Rechercher une équipe..."
              className="input input-bordered px-3 pl-10 pr-10 w-full max-w-sm h-11 text-sm text-gray-900 placeholder:text-gray-400"
            />
          </div>

          <select
            className="select select-bordered  ml-2"
            onChange={(e) => {
              setPrestataireId(e.target.value);
            }}
            disabled={loadingPrestataire}
          >
            <option value={""}>
              {loadingPrestataire ? "Chargement..." : "Choisir un prestataire"}
            </option>
            {prestataires?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.designation}
              </option>
            ))}
          </select>
        </div>

        <div className="grid md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8">
          {coordoList?.data?.donnee?.length === 0 ? (
            <div className="col-span-full flex flex-col items-center justify-center py-20">
              <p className="text-sm font-medium text-gray-900 mb-1">
                Aucun donnée pour le moment
              </p>
              <p className="text-xs text-gray-500 text-center px-4">
                Sélectionnez un prestataire pour voir ses coordonnateurs
              </p>
            </div>
          ) : coordoList?.data?.donnee?.length !== 0 && !coordoList?.loading ? (
            coordoList?.data?.donnee?.map((item) => (
              <NavLink
                to={`coordo/${item?.coordinateur?.id}/${encodeURIComponent(
                  item?.coordinateur?.nomPrenoms
                )}`}
                key={item?.id}
                className="group relative flex flex-col gap-2 p-3 border border-gray-200 bg-white hover:border-amber-400 hover:shadow-md rounded-lg transition-all duration-200"
              >
                <div className="flex items-start gap-3">
                  <div className="bg-blue-100 group-hover:bg-blue-200 w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors">
                    <UserMultipleIcon size={20} className="text-blue-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">
                      {item?.coordinateur?.nomPrenoms}
                    </p>
                    <div className="flex items-center gap-1 mt-1">
                      <Mail className="w-3 h-3 text-gray-400 flex-shrink-0" />
                      <p className="text-xs text-gray-500 truncate">
                        {item?.coordinateur?.email || "Non renseigné"}
                      </p>
                    </div>
                  </div>
                </div>
              </NavLink>
            ))
          ) : (
            <Loader />
          )}
        </div>
        {
          <div className="my-3 flex justify-end">
            <Pagination
              onChange={(event, newValue) => more(newValue)}
              onSelect={(selectedPage) => more(selectedPage)}
              count={coordoList?.data?.totalPages}
              variant="outlined"
              color="primary"
              shape="rounded"
            />
          </div>
        }
      </>
    </div>
  );
};
